import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Sidebar } from './Sidebar';
import { Navbar } from './Navbar';
import { CommandPalette } from './CommandPalette';
export function MainLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [commandOpen, setCommandOpen] = useState(false);
  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setCommandOpen(true);
      }
    };
    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, []);
  return <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-950" data-id="element-39">
      <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} data-id="element-40" />
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-41">
        <Navbar onCommandOpen={() => setCommandOpen(true)} data-id="element-42" />
        <main className="flex-1 overflow-y-auto" data-id="element-43">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3
        }} className="h-full" data-id="element-44">
            <Outlet data-id="element-45" />
          </motion.div>
        </main>
      </div>
      <AnimatePresence data-id="element-46">
        {commandOpen && <CommandPalette onClose={() => setCommandOpen(false)} data-id="element-47" />}
      </AnimatePresence>
    </div>;
}